"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _Controllable = _interopRequireDefault(require("../../decorators/Controllable"));

var _Functions = require("../../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _focusStylesListener = require("../../listeners/focusStylesListener");

var _Props = require("../../utils/Props");

var _refObject = _interopRequireDefault(require("../../utils/propTypes/refObject"));

var UISelectWithInputAnchor =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UISelectWithInputAnchor, _Component);

  function UISelectWithInputAnchor() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UISelectWithInputAnchor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UISelectWithInputAnchor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.focus = function () {
      if (_this._inputRef) {
        _this._inputRef.focus();
      }
    };

    _this.selectRefCallback = function (ref) {
      var selectRef = _this.props.selectRef;
      _this._selectRef = ref;

      if (selectRef) {
        selectRef(ref);
      }
    };

    _this.handleInputKeyDown = function (evt) {
      var readOnly = _this.props.readOnly;

      var internalSelect = _this.getInternalSelect();

      if (internalSelect && !readOnly) {
        internalSelect.handleKeyDown(evt);
      }
    };

    _this.handleInputChange = function (evt) {
      var onInputValueChange = _this.props.onInputValueChange;
      onInputValueChange(evt);

      var internalSelect = _this.getInternalSelect();

      if (internalSelect) {
        internalSelect.handleInputChange(evt);
      }
    };

    _this.handleInputFocus = function () {
      var _this$props = _this.props,
          onOpenChange = _this$props.onOpenChange,
          readOnly = _this$props.readOnly;

      var internalSelect = _this.getInternalSelect();

      if (readOnly) return;

      if (internalSelect) {
        internalSelect.setState({
          isOpen: true
        });
      }

      (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(true));
    };

    _this.handleInputBlur = function () {
      var onOpenChange = _this.props.onOpenChange;
      if (!(0, _focusStylesListener.isPageInKeyboardMode)()) return;
      (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(false));
    };

    return _this;
  }

  (0, _createClass2.default)(UISelectWithInputAnchor, [{
    key: "getInternalSelect",
    value: function getInternalSelect() {
      // Return our react-select component instance, or null
      if (!this._selectRef) {
        return null;
      }

      if (!this._selectRef.select) {
        return this._selectRef;
      } // _selectRef must be an <Async> or <Creatable> wrapper


      return this._selectRef.select;
    }
  }, {
    key: "getInternalAsyncSelect",
    value: function getInternalAsyncSelect() {
      // Return our react-select Async instance, or null
      if (!this._selectRef || !this._selectRef.select) {
        return null;
      }

      return this._selectRef;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          inputComponent = _this$props2.inputComponent,
          inputRef = _this$props2.inputRef,
          inputValue = _this$props2.inputValue,
          __onInputValueChange = _this$props2.onInputValueChange,
          __onOpenChange = _this$props2.onOpenChange,
          onPaste = _this$props2.onPaste,
          placeholder = _this$props2.placeholder,
          readOnly = _this$props2.readOnly,
          selectComponent = _this$props2.selectComponent,
          __selectRef = _this$props2.selectRef,
          tabIndex = _this$props2.tabIndex,
          value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["autoFocus", "disabled", "error", "inputComponent", "inputRef", "inputValue", "onInputValueChange", "onOpenChange", "onPaste", "placeholder", "readOnly", "selectComponent", "selectRef", "tabIndex", "value"]);
      var InputComponent = inputComponent;
      var SelectComponent = selectComponent;
      return _react.default.createElement("div", null, _react.default.createElement(InputComponent, (0, _extends2.default)({}, (0, _Props.getAriaAndDataProps)(rest), {
        autoFocus: autoFocus,
        disabled: disabled,
        "aria-invalid": error,
        inputRef: inputRef,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onKeyDown: this.handleInputKeyDown,
        onPaste: onPaste,
        placeholder: placeholder,
        readOnly: readOnly,
        ref: function ref(_ref) {
          _this2._inputRef = (0, _reactDom.findDOMNode)(_ref);
        },
        tabIndex: tabIndex,
        value: inputValue
      })), _react.default.createElement(SelectComponent, (0, _extends2.default)({}, rest, {
        autosize: false,
        className: "hidden",
        disabled: disabled,
        ref: this.selectRefCallback,
        scrollMenuIntoView: false,
        value: value
      })));
    }
  }]);
  return UISelectWithInputAnchor;
}(_react.Component);

UISelectWithInputAnchor.propTypes = {
  autoFocus: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  menuWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
  inputComponent: _propTypes.default.func.isRequired,
  inputRef: _refObject.default,
  isOpen: _propTypes.default.bool.isRequired,
  onInputValueChange: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  searchClassName: _propTypes.default.string,
  selectComponent: _propTypes.default.func.isRequired,
  selectRef: _propTypes.default.func,
  inputValue: _propTypes.default.string,
  value: _propTypes.default.any
};
UISelectWithInputAnchor.displayName = 'UISelectWithInputAnchor';

var _default = (0, _Controllable.default)(UISelectWithInputAnchor, ['inputValue']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/input/internal/UISelectWithInputAnchor.js
// module id = 638
// module chunks = 5 6